<template>
  <div>
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-btn class="mb-4" color="primary" @click="openDialogAdd = true">
          Adicionar acesso
        </v-btn>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
          class="mb-4"
        ></v-text-field>
        <v-data-table
          :headers="columns"
          :items="vivoGestaoAccesses"
          :search="search"
          locale="pt"
          :loading="loading"
        >
          <template v-slot:item.accounts="{ item }">
            <v-chip
              v-for="account in item.accounts"
              :key="account"
              small
              class="mr-1 mb-1"
            >
              {{ account }}
            </v-chip>
          </template>
          <template v-slot:item.active="{ item }">
            <v-icon v-if="item.active" small color="success">mdi-check</v-icon>
            <v-icon v-else small>mdi-close</v-icon>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon small class="mr-2" v-on="on" @click="showEditDialog(item)">
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on" @click="deleteAccess(item)">
                  mdi-delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <VivoGestaoAccessDialog
      v-if="openDialogAdd || openDialogEdit"
      :selected-item="selectedItem"
      @close="closeDialog"
      @saved="onSaved"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VivoGestaoAccessDialog from "@/components/dialog/integracaoConfig/VivoGestaoAccessDialog.vue";

export default {
  components: {
    VivoGestaoAccessDialog,
  },
  data() {
    return {
      loading: true,
      search: "",
      openDialogAdd: false,
      openDialogEdit: false,
      selectedItem: null,
      columns: [
        { text: "Descrição", value: "description" },
        { text: "Usuário", value: "username" },
        { text: "Contas", value: "accounts" },
        { text: "Situação", value: "active", align: "center" },
        { text: "", align: "end", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState("configurationIntegration", ["vivoGestaoAccesses"]),
  },
  async mounted() {
    await this.loadList();
  },
  methods: {
    ...mapActions("configurationIntegration", [
      "loadVivoGestaoAccesses",
      "deleteVivoGestaoAccess",
    ]),
    async loadList() {
      this.loading = true;
      try {
        await this.loadVivoGestaoAccesses();
      } catch (error) {
        this.$swal("Oops...", error.message, "error");
      }
      this.loading = false;
    },
    showEditDialog(item) {
      this.selectedItem = { ...item };
      this.openDialogEdit = true;
    },
    closeDialog() {
      this.selectedItem = null;
      this.openDialogAdd = false;
      this.openDialogEdit = false;
    },
    async onSaved() {
      this.closeDialog();
      await this.loadList();
    },
    async deleteAccess(item) {
      await this.$swal({
        icon: "warning",
        text: "Tem certeza que deseja excluir este acesso?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim!",
      }).then(async result => {
        if (result.value) {
          try {
            await this.deleteVivoGestaoAccess(item.id);
            this.$swal("Acesso removido com sucesso", "", "success");
            await this.loadList();
          } catch (error) {
            this.$swal("Oops...", error.message, "error");
          }
        }
      });
    },
  },
};
</script>
